import React from 'react';
import { useTranslation } from 'react-i18next';

const ClaimRewardModal = ({ rewardPoints, rewardType, onClose, isLuckyWheel, rewardName, prizeImage }) => {
    const { t } = useTranslation(['dailyMission']);

    return (
        <div className='modal-overlay'>
            <div className='modal-content'>
                <div className='modal-header-section'>
                    <h3>{isLuckyWheel ? t('dailyMission.luckyWheel') : t('dailyMission.dailyMission')}</h3>
                    <button className='close-button' onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className='modal-body'>
                    {isLuckyWheel ? (
                        <>
                            <h3>{t('dailyMission.congratulations')}</h3>
                            <h3>{t('dailyMission.youWin')}</h3>
                            <h3 className='reward-name'>{rewardName}</h3>
                            <div className='modal-image'>
                                <img src={`${prizeImage}`} alt={rewardName} />
                            </div>
                            <button className='confirm-button luckywheel-cta' onClick={onClose}>
                                {t('dailyMission.ok')}
                            </button>
                        </>
                    ) : (
                        <>
                            <h2>{t('dailyMission.congratulations')}</h2>
                            <div className='modal-image'>
                                <img src='/public/html/images/lucky-wheel/coin.png' alt='Coins' />
                            </div>
                            <p>{t('dailyMission.collected')}</p>
                            <h3>{t(`dailyMission.rewardType.${rewardType}`, { reward: rewardPoints })}</h3>
                            <button className='confirm-button' onClick={onClose}>
                                {t('dailyMission.confirm')}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClaimRewardModal;
